import { ReactNode, useCallback, useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface AdminLayoutProps {
  children: ReactNode;
  title?: string;
}

export function AdminLayout({ children, title }: AdminLayoutProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMobileClose = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const handleMenuClick = useCallback(() => {
    setIsMobileMenuOpen((prev) => !prev);
  }, []);

  return (
    <div className='flex h-screen overflow-hidden bg-background'>
      <Sidebar isMobileOpen={isMobileMenuOpen} onMobileClose={handleMobileClose} />
      <div className='flex-1 flex flex-col overflow-hidden lg:ml-0'>
        <Header title={title} onMenuClick={handleMenuClick} />
        <main className='flex-1 overflow-y-auto p-3 sm:p-4 lg:p-6 pb-safe'>{children}</main>
      </div>
    </div>
  );
}
